const styles = {};
export {
  styles as default
};
